import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Charging from 'pages/charging/Charging';
import OrderManagement from 'pages/charging/OrderManagement';
import ActivityCodeList from 'pages/charging/ActivityCodeList';
import ChargingMoneyManagement from 'pages/charging/ChargingMoneyManagement';

const ChargingRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Charging />} />
      <Route path="/order-management" element={<OrderManagement />} />
      <Route path="/activity-code-list" element={<ActivityCodeList />} />
      <Route path="/charging-money-management" element={<ChargingMoneyManagement />} />
    </Routes>
  );
};

export default ChargingRouter; 